module.exports = __webpack_public_path__ + "static/media/slide10.b7db933b.jpg";